import CrudRequest from '@rootCommon/services/crud-request';
import { NOTIFICATION_RULES } from '@rootCommon/constants/end-points';
import { NotificationRule } from '@rootCommon/types/site';
import { IdType } from '@rootCommon/types/common';
import { ADMIN } from '@rootCommon/constants/common';

const NOTIFICATION_RULES_ADMIN = `${NOTIFICATION_RULES}/${ADMIN}`;

class OrganizationRulesService extends CrudRequest<NotificationRule, NotificationRule> {
  constructor() {
    super(NOTIFICATION_RULES_ADMIN);
  }

  getBySiteId = async (siteId: IdType): Promise<NotificationRule> => {
    const res = await CrudRequest.get<NotificationRule>(NOTIFICATION_RULES_ADMIN, {
      params: { siteId },
    });

    return res.data;
  };

  updateBySiteId = async (siteId: IdType, notificationRules: NotificationRule[]): Promise<NotificationRule[]> => {
    const res = await CrudRequest.put<NotificationRule[], { notificationRules: NotificationRule[] }>(
      NOTIFICATION_RULES_ADMIN,
      { notificationRules },
      {
        params: { siteId },
      },
    );

    return res.data;
  };
}

export default new OrganizationRulesService();
